export const convertToBoolean = (value: string, optionsTrue: string[]) => {
  const lowercaseValue = value.toLowerCase()
  const lowercaseOptions = optionsTrue.map((option) => option.toLowerCase())
  const response = lowercaseOptions.some((option) => lowercaseValue === option)
  return response
}

// If there's another module which must accept certain strings as a true option, just add it below and export it
export const trueOptionsApprovalInstructions = ['yes', 'y']
